const composeBackendHostname = (host: string): string => {
  const hostnameArray = host.split('.')
  const environment = hostnameArray.length === 3 ? hostnameArray.shift() : undefined
  switch (environment) {
    case 'staging-admin':
      hostnameArray.unshift('staging-api')
      break
    case 'local':
    case 'admin':
      hostnameArray.unshift('api')
      break
    default:
      return host
  }
  return hostnameArray.join('.')
}

let backendHost
const protocol = (window && window.location && window.location.protocol) || 'http:'
const hostname = window && window.location && window.location.hostname
const port = window && window.location && window.location.port

if (process.env.REACT_APP_BACKEND_HOST) {
  backendHost = process.env.REACT_APP_BACKEND_HOST
} else if (hostname && hostname !== 'localhost') {
  backendHost = `${protocol}//${composeBackendHostname(hostname)}${port ? `:${port}` : ''}`
} else {
  backendHost = `${protocol}//api.foundernest.localhost`
}

export const API_ROOT = `${backendHost}/api/`
